import { createReactComponent } from '@tabler/icons-react';

export const IconCustomMenuDown = createReactComponent(
  'outline',
  'customMenuDown',
  'CustomMenuDown',
  [
    [
      'path',
      {
        key: 'customMenuDown-path',
        d: 'M15.3,10.4L12,13.6l-3.3-3.3',
      },
    ],
  ]
);
